import { Button, Grid, Stack, styled, Text } from '@ltvco/refresh-lib/theme';
import { CancelOutlined, CheckCircle } from '@mui/icons-material';

export const ActivateFreeAccessContainer: React.ComponentType<
  React.HTMLAttributes<HTMLDivElement>
> = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: theme.spacing(4),
  backgroundColor: theme.palette.background.paper,

  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2.5),
  },

  '> *': {
    width: '100%',

    [theme.breakpoints.up('md')]: {
      width: 800,
    },
  },
}));

export const TitleTag = styled(Text)(() => ({
  letterSpacing: 2.25,
  color: '#ff4722',
  fontWeight: 700,
  textTransform: 'uppercase',
  marginBottom: '1.25rem',
}));

export const HeaderText = styled(Text)(({ theme }) => ({
  fontWeight: 600,
  fontSize: 40,
  letterSpacing: -2,

  [theme.breakpoints.up('md')]: {
    fontSize: 48,
  },
}));

export const HeaderTextAccentColor = styled(Text)(({ theme }) => ({
  fontWeight: 600,
  display: 'inline',
  fontSize: 40,
  letterSpacing: -2,

  [theme.breakpoints.up('md')]: {
    fontSize: 48,
  },
}));

export const SubHeaderText = styled(Text)(() => ({
  fontSize: '1.25rem',
  fontWeight: 400,
  width: '87.5%',
  marginBottom: '2.5rem',
}));

export const GarageDetailsHeader = styled(Text)(() => ({
  fontSize: '1.25rem',
}));

export const GarageDetailsTable = styled('ul')(({ theme }) => ({
  marginTop: 12,
  listStyle: 'none',
  padding: 0,
  display: 'flex',
  flexWrap: 'wrap',

  '> *': {
    paddingBottom: '1.25rem',
    flex: '100%',

    [theme.breakpoints.up('md')]: {
      flex: '50%',
      paddingRight: '2rem',
    },
  },
}));

export const GarageDetailItemContainer = styled(Stack)(() => ({
  '> :first-child': {
    marginRight: 8,
  },
}));

export const PlanDetailsTable = styled(Grid)(({ theme }) => ({
  '> :nth-child(2n+3)': {
    backgroundColor: theme.palette.grey[200],
  },

  '>:last-child': {
    '.bumper-garage-item': {
      borderBottom: '4px solid #ff4722',
    },
  },
}));

export const GridRow = styled(Grid)(() => ({
  '&:first-child': {
    height: 8,

    '> *': {
      padding: 0,
    },
  },
}));

export const PlanDetailItemContainer = styled(Grid)(() => ({
  alignItems: 'center',
  padding: 16,
}));

export const PlanDetailItemIconContainer = styled(PlanDetailItemContainer)(
  ({ theme }) => ({
    justifyContent: 'center',

    '&.bumper-garage-header': {
      backgroundColor: '#ff4722',
      color: theme.palette.text.contrastText,
      fontWeight: 700,
      fontSize: '1.5rem',

      '&--extra': {
        height: 8,
      },
    },

    '&.bumper-garage-item': {
      borderLeft: '4px solid #ff4722',
      borderRight: '4px solid #ff4722',
    },

    '&.bumper-pro-header': {
      backgroundColor: theme.palette.grey[500],
    },

    '&.justify-start': {
      justifyContent: 'flex-start',
    },
  }),
);

export const PlanDetailItemText = styled(Text)(() => ({
  fontWeight: 700,
}));

export const OrangeCheckCircle = styled(CheckCircle)(() => ({
  color: '#ff4722',
}));

export const GreyCancelOutlined = styled(CancelOutlined)(({ theme }) => ({
  color: theme.palette.grey[500],
}));

export const BumperColumnHeader = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.5rem',

  '&.white-text': {
    color: theme.palette.text.contrastText,

    fontSize: '1rem',

    [theme.breakpoints.up('md')]: {
      fontSize: '1.5rem',
    },
  },
}));

export const ActivateButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.common.black,
  color: theme.palette.text.contrastText,
  width: 'fit-content',
  margin: '3rem auto 7rem',
  padding: '1rem 2rem',
}));
